import Image from "next/image"
import { useRef } from "react"
import { IoCamera } from "react-icons/io5"
import useT from "utils/useT"

type Props = {
  photoURL?: string | Blob
  onFileUpload: (file: Blob) => void
}

const ProfileImage = ({ photoURL, onFileUpload }: Props) => {
  const t = useT()
  const inputRef = useRef<HTMLInputElement>(null)
  const imageUrl = photoURL
    ? typeof photoURL === "string"
      ? photoURL
      : URL.createObjectURL(photoURL)
    : "/images/avatars/4m.png"

  return (
    <div
      onClick={() => inputRef?.current?.click()}
      className="position-relative curser-pointer"
    >
      <Image
        className="rounded-circle img-profile"
        width={100}
        height={100}
        src={imageUrl}
        style={{ objectFit: "cover", opacity: photoURL ? 1 : 0.25 }}
        alt="profile photo"
        priority
        unoptimized
      />
      {!photoURL && (
        <p className="position-absolute" style={{ inset: 0, top: 40 }}>
          {t.signup.addPhoto}
        </p>
      )}
      <IoCamera className="signup-photo" />
      <input
        ref={inputRef}
        onChange={(e) => onFileUpload(e.target.files![0])}
        type="file"
        id="file-upload"
        role="button"
        className="upload-file bg-highlight shadow-l rounded-sm d-none"
        accept="image/*"
      />
    </div>
  )
}

export default ProfileImage
